module.exports = __webpack_public_path__ + "img/test_status_0.0d178261.png";